import { isNotEmpty } from './checkers'
import { clearDigitsSpecialChars } from './parsers'
import currency from 'currency.js';


export function formatCpf(value) {
    let rawValue = clearDigitsSpecialChars(value)

    let newValue = rawValue.substr(0, 3)

    if (rawValue.length > 3) {
        newValue  += '.' + rawValue.substr(3, 3)
    }

    if (rawValue.length > 6) {
        newValue  += '.' + rawValue.substr(6, 3)
    }

    if (rawValue.length > 9) {
        newValue += '-' + rawValue.substr(9, 2)
    }

    return newValue
}

export function formatCnpj(value) {
    let rawValue = clearDigitsSpecialChars(value)

    let newValue = rawValue.substr(0, 2)

    if (rawValue.length > 2) {
        newValue  += '.' + rawValue.substr(2, 3)
    }

    if (rawValue.length > 5) {
        newValue  += '.' + rawValue.substr(5, 3)
    }

    if (rawValue.length > 8) {
        newValue  += '/' + rawValue.substr(8, 4)
    }

    if (rawValue.length > 12) {
        newValue += '-' + rawValue.substr(12, 2)
    }

    return newValue
}

export function firstChar(value) {
    if(value)
        return value[0];

    return "";
}

export function formatPhone(value) {
    let rawValue = clearDigitsSpecialChars(value)

    let front = 4
    if (rawValue.length > 10) {
        front = 5
    }

    let newValue = ''
    if (rawValue.length > 0) {
        newValue  += '(' + rawValue.substr(0, 2)
    }

    if (rawValue.length > 2) {
        newValue  += ') ' + rawValue.substr(2, front)
    }

    if (rawValue.length >= 7) {
        newValue += '-' + rawValue.substr(front + 2, 4)
    }

    return newValue
}

export function formatCep(value) {
    let rawValue = clearDigitsSpecialChars(value)

    let newValue = rawValue.substr(0, 2)

    if (rawValue.length > 2) {
        newValue  += '.' + rawValue.substr(2, 3)
    }

    if (rawValue.length > 5) {
        newValue  += '-' + rawValue.substr(5, 3)
    }

    return newValue
}

export function formatCurrency(value) {
    if (value < 0) {
        let rawValue = clearDigitsSpecialChars(value)
        let number = currency(rawValue, { fromCents: true, precision: 3, separator: '.', decimal: ',', symbol: 'R$ -'}).format();
        return number;
    }
    let rawValue = clearDigitsSpecialChars(value)
    let number = currency(rawValue, { fromCents: true, precision: 3, separator: '.', decimal: ',', symbol: 'R$ '}).format();
    return number;
}

export function formatQuantidade(value) {
    if (value < 0) {
        let Value = clearDigitsSpecialChars(value)
        let result = currency(Value, { separator: '.', precision: 0, symbol: "-" }).format();
        return result;
    }
    let Value = clearDigitsSpecialChars(value)
    let result = currency(Value, { separator: '.', precision: 0, symbol: "" }).format();
    return result;
}

export function formatDate(value) {
    let rawValue = clearDigitsSpecialChars(value)

    let newValue = rawValue.substr(0, 2)

    if (rawValue.length > 2) {
        newValue  += '/' + rawValue.substr(2, 2)
    }

    if (rawValue.length > 4) {
        newValue  += '/' + rawValue.substr(4, 4)
    }

    return newValue
}

export function datePickerFormatter(value) {
    let splitValue = value.split('/');
    return new Date(splitValue[2], splitValue[1] - 1, splitValue[0]);
}

export function formatPropertyType(tipo, contracted = false) {
    if (!tipo) return "Imóvel";

    if(typeof(tipo) !== "number") tipo = parseInt(tipo, 0);

    switch (tipo) {
        case 1:
            return contracted ? "APTO" : "Apartamento"
        case 2:
            return "Casa"
        case 3:
            return "Galpão"
        case 4:
            return "Garagem"
        case 5:
            return contracted ? "Loja ou Sala" :  "Loja ou Sala comercial"
        case 6:
            return contracted ? "Chác., Faz. ou Sítio" :  "Chácara, Fazenda ou Sítio"
        case 7:
            return "Terreno"
        default:
            return "Imóvel";
    }
}

export function formatPropertyPermission(permission) {
    let keys = Object.keys(permission).filter(it => permission[it] === true)
    let result = keys.join(' / ')
    result = result.replace('inserir', 'Inserir')
                .replace('editar', 'Editar')
                .replace('replicar', 'Replicar no site')

    return result
}

export function formatUserType(value) {
    if (!value) return "Pessoa";

    if(typeof(value) !== "number") value = parseInt(value, 0);

    switch (value) {
        case 1:
            return "Pessoa"
        case 2:
            return "Corretor"
        case 3:
            return "Imobiliária"
        case 4:
            return "Construtora"
        case 999:
            return "Administrador"
        default:
            return "Pessoa";
    }
}

export function formatEstadoCivil(value) {
    if (!value) return "Solteiro";

    if(typeof(value) !== "number") value = parseInt(value, 0);

    switch (value) {
        case 1:
            return "Solteiro"
        case 2:
            return "Casado"
        case 3:
            return "União Estável"
        case 4:
            return "Divorciado"
        case 5:
            return "Viúvo"
        default:
            return "Solteiro";
    }
}

export function formatTimestampToDate(timestamp) {
    let date = new Date(timestamp * 1000)
    return date.toLocaleDateString()
}

export function formatPropertyCode(id) {
    let str = id.toString()
    return `Cod. ${str.padStart(4, "0")}`;
}

export function formatPropertyIdentification(imovel) {
    let rua = "Sem rua"
    if (imovel.endereco) {
        rua = imovel.endereco.rua
    }

    return `${rua} (${formatPropertyCode(imovel.id)})`
}

export function formatPermissionPropertyIdentification(permission) {
    let rua = "Sem rua"
    if (permission.endereco) {
        rua = permission.endereco.rua
    }

    return `${rua} (${formatPropertyCode(permission.id_imovel)})`
}

export function formatIdentificadorPagina(value) {
    let characters = value.match(/[A-Z0-9a-z\\-_]/g)
    return characters !== null ? characters.join('') : ""
}
export function itemIdFormater(value) {
    
    switch(String(value).length){
        case 0:
            return ('')

        case 1:
            return (`000${(value)}`)

        case 2:
            return (`00${(value)}`)

        case 3:
            return (`0${(value)}`)

        default:
            return value
        }
}





// WEBPACK FOOTER //
// ./src/common/formaters.js